import type { ThemeKey, DefaultThemeStyles } from 'Src/types/theme';
import type { CSSProperties, ReactNode } from 'react';
import React from 'react';
import { Capsule } from 'Components/frameworks/capsule/Capsule';
import { CollapsePanel } from 'Components/frameworks/collapse-panel/CollapsePanel';
import type { IconName } from 'Components/frameworks/icon/Icon';
import { Icon } from 'Components/frameworks/icon/Icon';
import { themes } from './CapsuleCollapseLists.themes';
type CapsuleCollapseListsProps = {
  className?: string;
  header?: {
    color?: string;
    iconName?: IconName;
    title?: string;
  };
  lists:
    | Array<{
        items:
          | Array<{
              iconName?: IconName;
              label: string;
            }>
          | null
          | undefined;
        title: string;
      }>
    | null
    | undefined;
  message?: ReactNode;
  style?: CSSProperties;
  theme?: ThemeKey<typeof themes>;
};
export const CapsuleCollapseLists = ({
  className,
  header = {},
  lists = [],
  message,
  style,
  theme = 'default',
}: CapsuleCollapseListsProps) => {
  if (!lists || !lists.length) {
    return null;
  }

  const {
    thCapsuleContent,
    thCollapse,
    thCollapseIconCollapse,
    thCollapseIconExpand,
    thCollapseTheme,
    thItems,
    thItem,
    thItemIcon,
    thItemIconWidth,
    thItemLabel,
    thMessage,
  } = themes[theme] as DefaultThemeStyles<typeof themes>;
  return (
    <Capsule
      additionalStyle={{
        root: style,
      }}
      className={className}
      color={header.color}
      contentClassName={thCapsuleContent}
      header="large"
      icon={header.iconName}
      label={header.title}
    >
      {!!message && <p className={thMessage}>{message}</p>}
      {lists.map(
        (el, index) =>
          !!el.items?.length && (
            <CollapsePanel
              className={thCollapse}
              collapseIconName={thCollapseIconCollapse}
              expandIconName={thCollapseIconExpand}
              isExpanded={index === 0}
              key={el.title}
              theme={thCollapseTheme as 'default' | 'limpidSmall' | 'homeDetails' | 'remote'}
              title={el.title}
            >
              <ul className={thItems}>
                {el.items.map(({ iconName, label }) => (
                  <li className={thItem} key={label}>
                    <Icon className={thItemIcon} name={iconName} width={thItemIconWidth} />
                    <span className={thItemLabel}>{label}</span>
                  </li>
                ))}
              </ul>
            </CollapsePanel>
          ),
      )}
    </Capsule>
  );
};
